// extracted by mini-css-extract-plugin
export default {"address":"editPrint_address__V1qCJ","formFields":"editPrint_formFields__FYZeH","corner_button":"editPrint_corner_button__XSsOK","display_text":"editPrint_display_text__8O7tF"};